import React from 'react';
import Icon from '../AppIcon';
import './StarRating.css';

const StarRating = ({ rating = 0, reviewCount = 0, size = 'md' }) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    const starSize = size === 'sm' ? 16 : size === 'lg' ? 24 : 20;

    return (
        <div className="rating-section flex items-center gap-2 mb-2">
            <div className="stars flex gap-0.5">
                {/* Full stars */}
                {Array(fullStars).fill().map((_, i) => (
                    <Icon
                        key={`full-${i}`}
                        name="Star"
                        size={starSize}
                        className="text-yellow-400 fill-current"
                    />
                ))}

                {/* Half star */}
                {hasHalfStar && (
                    <div key="half" className="relative">
                        <Icon
                            name="Star"
                            size={starSize}
                            className="text-gray-300"
                        />
                        <div className="absolute inset-0 overflow-hidden w-1/2">
                            <Icon
                                name="Star"
                                size={starSize}
                                className="text-yellow-400 fill-current"
                            />
                        </div>
                    </div>
                )}

                {/* Empty stars */}
                {Array(emptyStars).fill().map((_, i) => (
                    <Icon
                        key={`empty-${i}`}
                        name="Star"
                        size={starSize}
                        className="text-gray-300"
                    />
                ))}
            </div>

            <span className="rating-text text-sm font-medium text-gray-700">
                {parseFloat(rating || 0).toFixed(1)}
            </span>
            {reviewCount > 0 && (
                <span className="review-count text-sm text-gray-500">
                    ({reviewCount})
                </span>
            )}
        </div>
    );
};

export default StarRating; 